import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://static.readdy.ai/image/a07a911c26a50ba40c2df7c423ae5027/60f09cc48ebab0b35cac7795610072c5.jpeg";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#070d1a]/95 backdrop-blur-md border-b border-[#D4AF37]/20 shadow-lg shadow-black/40"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <div className="w-10 h-10 rounded-lg overflow-hidden border border-[#D4AF37]/40">
            <img src={LOGO_URL} alt="Web2Revenue Logo" className="w-full h-full object-cover" />
          </div>
          <span className="text-white font-bold text-xl tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            WEB<span className="text-[#D4AF37]">2</span>REVENUE
          </span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {[
            { label: "Services", id: "services" },
            { label: "Portfolio", id: "portfolio" },
            { label: "Why Us", id: "why-us" },
            { label: "Contact", id: "cta" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white/80 hover:text-[#D4AF37] text-sm font-medium tracking-wider uppercase transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA Button */}
        <div className="hidden md:block">
          <button
            onClick={() => scrollTo("cta")}
            className="bg-[#D4AF37] hover:bg-[#c4a030] text-[#070d1a] font-bold text-sm px-7 py-3 rounded-full tracking-wider uppercase transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Start Project
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
        >
          <i className={`text-white text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        } bg-[#070d1a]/98 border-t border-[#D4AF37]/20`}
      >
        <div className="flex flex-col px-6 py-6 gap-5">
          {[
            { label: "Services", id: "services" },
            { label: "Portfolio", id: "portfolio" },
            { label: "Why Us", id: "why-us" },
            { label: "Contact", id: "cta" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white/80 hover:text-[#D4AF37] text-sm font-medium tracking-wider uppercase text-left transition-colors duration-300 cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("cta")}
            className="bg-[#D4AF37] text-[#070d1a] font-bold text-sm px-7 py-3 rounded-full tracking-wider uppercase w-full whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Start Project
          </button>
        </div>
      </div>
    </nav>
  );
}
